import React from 'react';
import { AlertContainer } from './styles';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../global/constants';

interface AlertProps {
  type: 'success' | 'error' | 'warning';
  message: string;
  onClose?: () => void;
}

const AlertMessage: React.FC<AlertProps> = ({ type, message, onClose }) => {
  return (
    <AlertContainer>
      {type === 'success' && (
        <SVGIcon
          name='true-icon'
          width={ICON_SIZE.XL}
          height={ICON_SIZE.XL}
          viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
          fill='var(--accent-success)'
        />
      )}
      {type === 'warning' && (
        <SVGIcon
          name='warning-icon'
          width={ICON_SIZE.XL}
          height={ICON_SIZE.XL}
          viewBox={`0 0 ${ICON_SIZE.XL} ${ICON_SIZE.XL}`}
        />
      )}
      {type === 'error' && (
        <SVGIcon
          name='error-icon'
          width={ICON_SIZE.XL}
          height={ICON_SIZE.XL}
          viewBox={`0 0 ${ICON_SIZE.XL} ${ICON_SIZE.XL}`}
        />
      )}
      <span>{message}</span>
    </AlertContainer>
  );
};

export default AlertMessage;
